<template>
  <ul class="desktop-share-body">
    <li
      :class="['share-item', region, item.id]"
      v-for="item in desktop_share_items"
      :key="item.id"
      @click="toShare(item)"
      :title="item.name"
    >
      <img
        :class="['share-item-logo', item.id]"
        v-lazy="item.icon"
        alt="logo"
      />
    </li>
  </ul>
</template>
<script>
  import { desktop_share_items, facebook_app_id } from './consts'
  import {
    shareToEmail,
    shareToFacebook,
    shareToMessenger,
    shareToTwitter,
    shareToWhatsApp,
    shareToVK,
    shareToTelegram,
  } from '@/utils/share'
  import { getEnv } from '@/utils/env'
  import { setRouteBase } from '@/config/routePrefix'
  import { mapState } from 'vuex'

  export default {
    name: 'desktop-share',
    data() {
      return {
        desktop_share_items,
        shareInfos: {},
      }
    },
    computed: {
      ...mapState(['region', 'gameName']),
    },
    mounted() {
      this.setShareInfos()
    },
    methods: {
      setShareInfos(configs) {
        if (configs && typeof configs === 'object') {
          this.shareInfos = configs
        } else {
          const fix = setRouteBase() === '/' ? '' : setRouteBase()
          const shareTitle = 'TopLupe - Trust & Bonus'
          const hostMaps = {
            test: 'https://www-staging.toplupe.com',
            preview: window.location.origin,
            online: window.location.origin,
          }
          const shareUrl = `${hostMaps[getEnv()]}${fix}/${
            this.gameName
          }?source=share`
          this.shareInfos = {
            shareTitle,
            shareUrl,
          }
        }
      },
      toShare(item) {
        const { id = '' } = item || {}
        const { shareTitle, shareUrl } = this.shareInfos
        const shareInfos = { shareTitle, shareUrl }

        this.$emit('toShare', item)
        shareInfos.shareUrl = `${shareInfos.shareUrl}&channelId=${id}`
        shareInfos.app_id = facebook_app_id

        const shareMethods = {
          facebook: shareToFacebook,
          twitter: shareToTwitter,
          whatsapp: shareToWhatsApp,
          email: shareToEmail,
          messenger: shareToMessenger,
          vk: shareToVK,
          telegram: shareToTelegram,
        }
        shareMethods[id.toLocaleLowerCase()](shareInfos)
      },
    },
  }
</script>
<style lang="scss" src="./desktop.scss"></style>
